export default "For this last section of the workshop, we're going to cover a topic that you might have heard about: generative AI\n"